import React, { useState } from 'react';
import { FileText, Loader, CheckCircle, AlertCircle, Download } from 'lucide-react';
import { generateReport, downloadReport } from '../services/ReportAPI';
import { getCurrentUserId } from '../services/apiConfig';

const GenerateReportButton = ({ results, patient, className = '' }) => {
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState(null);

  const handleGenerate = async () => {
    if (!results || status === 'generating') return;
    const user_id = getCurrentUserId();
    if (!user_id) {
      setStatus('error');
      setMessage('No user session found. Please log in again.');
      return;
    }

    const vitals = { ...(results.all_vital_results || {}) };
    ["id", "training_data_id", "created_at", "updated_at", "scan_user"].forEach((k) => delete vitals[k]);
    if (!Object.keys(vitals).length) {
      vitals.heart_rate = results.heart_rate;
      vitals.bp_systolic = results.bp_systolic;
      vitals.bp_diastolic = results.bp_diastolic;
      vitals.hrv_sdnn = results.hrv_sdnn;
      vitals.hrv_rmssd = results.hrv_rmssd;
      vitals.spo2 = results.spo2;
      vitals.resp_rate = results.resp_rate;
      vitals.hemoglobin = results.hemoglobin;
      vitals.confidence = results.confidence;
      vitals.duration = results.duration;
      vitals.frames_analyzed = results.frames_analyzed;
    }

    setStatus('generating');
    setMessage(null);
    try {
      const data = await generateReport({
        user_id,
        patient_name: patient?.patientName,
        age: patient?.age,
        gender: patient?.gender,
        vital_results: vitals,
        vital_scan_id: results.scan_id,
      });
      if (data && data.success && data.data) {
        const { id, report_filename } = data.data;
        setStatus('success');
        setMessage(`Report "${report_filename}" generated. Downloading...`);
        const blob = await downloadReport(id, user_id);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = report_filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } else {
        setStatus('error');
        setMessage('Unexpected server response.');
      }
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Failed to generate report.');
    }
  };

  const isGenerating = status === 'generating';

  return (
    <div className={`grp-wrap ${className}`}>
      <button
        className="grp-btn"
        onClick={handleGenerate}
        disabled={isGenerating}
      >
        {isGenerating ? <Loader size={18} className="grp-spin" /> : <FileText size={18} />}
        {isGenerating ? 'Generating Report...' : 'Generate Report'}
      </button>
      {message && (
        <div className={`grp-msg ${status}`}>
          {status === 'success' ? <CheckCircle size={14} /> : status === 'error' ? <AlertCircle size={14} /> : <Download size={14} />}
          <span>{message}</span>
        </div>
      )}
    </div>
  );
};

export default GenerateReportButton;
